import { render, staticRenderFns } from "./OrderListView.vue?vue&type=template&id=c0656772&scoped=true"
import script from "./OrderListView.vue?vue&type=script&lang=js"
export * from "./OrderListView.vue?vue&type=script&lang=js"
import style0 from "./OrderListView.vue?vue&type=style&index=0&id=c0656772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0656772",
  null
  
)

export default component.exports